// 登录态统一存储在 sessionStorage 中（每个标签页/窗口独立，刷新不丢失，新开标签页需重新登录），
// 避免同一浏览器多标签页共享 Cookie/localStorage 导致不同账号的 token、用户信息相互覆盖串改
const TokenKey = 'system_token'
const UserInfoKey = 'system_userInfo'
const PermissionsKey = 'system_permissions'

export function getToken() {
  return sessionStorage.getItem(TokenKey)
}

export function setToken(token) {
  return sessionStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return sessionStorage.removeItem(TokenKey)
}

export function getUserInfo() {
  const userInfo = sessionStorage.getItem(UserInfoKey)
  return userInfo ? JSON.parse(userInfo) : null
}

export function setUserInfo(userInfo) {
  return sessionStorage.setItem(UserInfoKey, JSON.stringify(userInfo))
}

export function removeUserInfo() {
  return sessionStorage.removeItem(UserInfoKey)
}

export function getPermissions() {
  const permissions = sessionStorage.getItem(PermissionsKey)
  return permissions ? JSON.parse(permissions) : []
}

export function setPermissions(permissions) {
  return sessionStorage.setItem(PermissionsKey, JSON.stringify(permissions))
}

export function removePermissions() {
  return sessionStorage.removeItem(PermissionsKey)
}
